export const ANALYTICS_EVENTS = {
  APP_OPENED: 'app_opened',
  GAME_OPENED: 'game_opened',
  GAME_STARTED: 'game_started',
  CELL_FILLED: 'cell_filled',
  PING_SENT: 'ping_sent',
  SHARE_INITIATED: 'share_initiated',
  SHARE_COMPLETED: 'share_completed',
  PUZZLE_COMPLETED: 'puzzle_completed',
  UPLOAD_STARTED: 'upload_started',
  SETTINGS_UPDATED: 'settings_updated',
  NOTIFICATION_OPT_IN_CHANGED: 'notification_opt_in_changed',
  NOTIFICATION_OPENED: 'notification_opened',
  FUN_MORGO_EGG: 'fun_morgo_egg',
}
